module.exports = __webpack_public_path__ + "img/my.af3c3e9b.svg";